import React, { Component } from "react";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import queryString from "query-string";
import AuthenticationActions, {
  AuthenticationSelectors
} from "Redux/AuthenticationRedux";
import { purgeData } from "Transforms/DataTransforms";

const RenderSuccess = props => {
  return (
    <SweetAlert
      success
      confirmBtnText="Close"
      confirmBtnBsStyle="default"
      cancelBtnBsStyle="default"
      title="Email Authenticated"
      onConfirm={props.onConfirm}
    >
      Your email has been authenticated
    </SweetAlert>
  );
};

const RenderError = props => {
  return (
    <SweetAlert
      danger
      confirmBtnText="Close"
      confirmBtnBsStyle="default"
      cancelBtnBsStyle="default"
      title="Error"
      onConfirm={props.onConfirm}
    >
      There was an error;
    </SweetAlert>
  );
};

class AuthenticateEmailScreen extends Component {
  state = {
    showSuccess: true,
    showError: true,
    navigate: false
  };

  componentDidMount() {
    const { location, authenticateEmail } = this.props;
    const token = queryString.parse(location.search);
    purgeData();
    localStorage.setItem("access", token.q);
    authenticateEmail(token.q);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.emailAuthenticated !== this.props.emailAuthenticated) {
      this.setState({
        showSuccess: true
      });
    }
  }

  sweetAlertSuccessClose = () => {
    const { registrationComplete, history } = this.props;

    if (registrationComplete) {
      history.push("/Feed");
    } else {
      history.push("/");
    }
  };

  sweetAlertFailureClose = () => {
    return;
  };

  render() {
    const { showSuccess } = this.state;
    return (
      <div className={"mainContainer"}>
        {showSuccess ? (
          <RenderSuccess onConfirm={this.sweetAlertSuccessClose} />
        ) : (
          <RenderError onConfirm={this.sweetAlertFailureClose} />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    emailAuthenticated: AuthenticationSelectors.getEmailAuthenticated(state),
    isAuthenticated: AuthenticationSelectors.getAuthenticated(state),
    fetching: AuthenticationSelectors.getFetching(state),
    registrationComplete: AuthenticationSelectors.getRegistrationComplete(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    authenticateEmail: data =>
      dispatch(AuthenticationActions.authenticateEmailRequest(data)),
    authenticationCheck: () =>
      dispatch(AuthenticationActions.authenticationCheckRequest()),
    resetRedux: () => dispatch(AuthenticationActions.resetRedux())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticateEmailScreen);
